
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { CommonButton } from '../../../../components/buttons';
import { isValidNameWithSpace, renderAutoCompleteSingleSelect, renderTextArea } from '../../../../components/reduxFields';
import { cancelAppointments, getMasterData } from './actions/manageAppointmentAction';
import React from 'react';
import Dialog from 'material-ui/Dialog';

const validate = (values) => {
  const errors = {};
  if (!values.CancelTypeId || !Number.isInteger(values.CancelTypeId)) {
    errors.CancelTypeId = 'Please select cancel type.';
  }
  if (!values.CancelReason) {
    errors.CancelReason = 'Please enter cancellation reason.';
  }

  return errors;
};

class CancelAppointmentDialogs extends React.Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleChangeCancelType = this.handleChangeCancelType.bind(this);
  }

  componentWillMount() {
    let masterData = {
      'masterdata': 'MASTERCANCELTYPE',
    };
    this.props.getMasterData(masterData);
  }

  handleChangeCancelType(input, selectedValue) {
    input.onChange(selectedValue.value);
  }

  onSubmit(formProps) {
    let apptIds = [];    
    apptIds = this.props.patientAppointmentId;
    formProps['Ids'] = apptIds;
    // console.log('form data...', JSON.stringify(formProps));
    this.props.cancelAppointments(formProps);
    this.props.closeCancelAppointmentDialog();
  }

  render() {
    const { showCancelAppointmentDialog, masterCancelType, handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.props.closeCancelAppointmentDialog()}/>,
      <CommonButton type="submit" primary={true} label= "Submit" onTouchTap={handleSubmit(this.onSubmit)}/>,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={'Cancel Appointment(S)'}
          modal={false}
          open={showCancelAppointmentDialog}
          actions={actions}
          autoScrollBodyContent={true}
        >
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form">
                <div className="row">
                  <div className="col-sm-12 require mt-40">
                    <Field
                      name="CancelTypeId"
                      label="Cancel Type"
                      options={masterCancelType || []}
                      disabled={this.props.initialValues && this.props.initialValues.CancelTypeId ? true : false}
                      handleNewRequest={this.handleChangeCancelType}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                  <div className="col-sm-12 require">
                    <Field
                      name="CancelReason"
                      type="text"
                      maxLength="1000"
                      floatingLabelText="Cancellation Reason"
                      normalize = {isValidNameWithSpace}
                      component={renderTextArea}
                      fullWidth={true}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let initialData = null;  
  return {
    initialValues: initialData,
    masterCancelType: state.manageAppointments.master_data ? state.manageAppointments.master_data.masterCancelType : [],
  };
};

CancelAppointmentDialogs = reduxForm({
  form: 'CancelAppointmentDialogs', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(CancelAppointmentDialogs);

export default connect(mapStateToProps, { cancelAppointments, getMasterData })(CancelAppointmentDialogs);



// WEBPACK FOOTER //
// ./src/modules/ManageAppointments/components/appointments/cancelAppointmentDialogs.js